/**
 * الوضع الفاتح/الداكن: «تلقائى» يتبع النظام (لا سمة على <html>)، والفاتح والداكن يُفرضان
 * بـ `data-theme`. الاختيار تفضيل للمتصفح وحده فيُحفظ محليًا — لا يذهب للخادم.
 * `public/theme-boot.js` يطبّقه قبل أول رسم حتى لا تومض الصفحة باللون الآخر.
 */
export type ThemePreference = 'auto' | 'light' | 'dark';

export const THEME_STORAGE_KEY = 'hesabat.theme';

const ORDER: readonly ThemePreference[] = ['auto', 'light', 'dark'];

export const THEME_LABELS: Record<ThemePreference, string> = {
  auto: 'تلقائى (حسب الجهاز)',
  light: 'فاتح',
  dark: 'داكن',
};

export function nextTheme(current: ThemePreference): ThemePreference {
  return ORDER[(ORDER.indexOf(current) + 1) % ORDER.length] ?? 'auto';
}

export function parseTheme(value: string | null | undefined): ThemePreference {
  return value === 'light' || value === 'dark' ? value : 'auto';
}

export function readTheme(): ThemePreference {
  try {
    return parseTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    // تخزين محجوب (تصفح خاص) — التلقائى يكفى
    return 'auto';
  }
}

export function applyTheme(preference: ThemePreference): void {
  const root = document.documentElement;
  if (preference === 'auto') delete root.dataset.theme;
  else root.dataset.theme = preference;
  try {
    if (preference === 'auto') window.localStorage.removeItem(THEME_STORAGE_KEY);
    else window.localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    // لا مكان للحفظ: يبقى الاختيار لهذه الجلسة فقط
  }
}
